import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CuiDrawerComponent } from '@idealink-material/ui-core';
import { TranslatePipe } from '@ngx-translate/core';
import { SignalFormValidationService } from '@/core/service/signal-form-validation.service';

const SEVERITY_STYLE: Record<string, { background: string; color: string }> = {
    success: { background: 'var(--status-approved-bg)', color: 'var(--status-approved-text)' },
    info: { background: 'var(--status-processing-bg)', color: 'var(--status-processing-text)' },
    warn: { background: 'var(--status-pending-bg)', color: 'var(--status-pending-text)' },
    error: { background: 'var(--status-rejected-bg)', color: 'var(--status-rejected-text)' }
};

@Component({
    selector: 'app-form-errors-message',
    standalone: true,
    imports: [CuiDrawerComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './form-errors-message.html'
})
export class FormErrorsMessage {
    visible = input<boolean>(false);
    visibleChange = output<boolean>();

    errorMessages = inject(SignalFormValidationService);

    onVisibleChange(v: boolean) {
        this.errorMessages._showMessage.set(v);
        this.visibleChange.emit(v);
    }

    severityStyle(severity: string) {
        return SEVERITY_STYLE[severity] ?? SEVERITY_STYLE['info'];
    }
}
